import React, { Component } from 'react';
import { connect } from 'react-redux';
import { selectSelectedTag, getSelectedUsers, getTagsSuccess, selectTags } from 'redux/tags/selectors';
import { selectUsers, toggleUserDialog, fetchTags, selectTag, clearUsersSelection, removeUsersTagsToggle } from 'redux/tags/actions';
import { fetchUsers, selectUser, updateUsersData } from 'redux/users/actions';
import { getUsers, getUsersPending, getUsersSuccess, getUsersFailure, getUsersNext } from 'redux/users/selectors';
import { selectSegments, getSegmentsStatus } from 'redux/segments/selectors';
import { bindAll, get } from 'lodash';

import Sidebar from './Sidebar';
import Title from './Title';
import Filters from './Filters';
import AddTag from './AddTag';
import RemoveUsersTags from './RemoveUsersTags';
import UsersTable from './UsersTable';
import Details from './Details';
import Header from './Header';
import { Container, Main } from './Users.styles';

export class Users extends Component {
  constructor(props) {
    super(props);

    this.tagsLoaded = false;
    this.segmentsLoaded = false;
    this.state = {
      openSidebar: true,
    };

    bindAll(this, ['toggleSidebar']);
  }

  componentDidMount() {
    this.fetchInit();
    this.props.fetchTagsData();
    this.triggerLinkActions();
  }

  componentDidUpdate(prevProps) {
    const segment = this.props.selectedTag.segment;
    const currentTagId = this.props.selectedTag.id;
    const is_identified = this.props.selectedTag.is_identified;
    const tag_id = !segment ? currentTagId : false;
    const segment_id = segment ? currentTagId : false;

    if (this.shouldFetchUsersFromUrl(prevProps)) this.props.fetchUsersData({ tag_id, segment_id, is_identified });
    if (!this.tagsLoaded) this.loadTagsFromUrl();
  }

  fetchInit() {
    if (this.getTagId(this.props.location)) return false;
    this.props.fetchUsersData();
  }

  shouldFetchUsersFromUrl(prevProps) {
    const prevTagId = prevProps.selectedTag.id;
    const currentTagId = this.props.selectedTag.id;

    const prev_is_identified = prevProps.selectedTag.is_identified;
    const is_identified = this.props.selectedTag.is_identified;

    return (prevTagId !== currentTagId) || (prev_is_identified !== is_identified);
  }

  loadTagsFromUrl() {
    const { tags, segments, tagSuccess, segmentsStatus, location } = this.props;
    const segmentSuccess = segmentsStatus.success;
    if (tagSuccess) this.tagsLoaded = true;
    if (segmentSuccess) this.segmentsLoaded = true;
    if (!this.tagsLoaded || !this.segmentsLoaded) return false;

    const tag_id = this.getTagId(location);
    const segment_id = this.getSegmentId(location);
    const is_identified = this.getIsIdentifyStatus(location);
    const selectedTag = tags.find(tag => tag.id === tag_id);
    const selectedSegment = segments.find(segment => segment.id === segment_id);

    if (selectedTag) this.props.selectTag(selectedTag);
    else if (tag_id) this.props.selectTag({ id: tag_id, name: 'Tag not found' });
    else if (segment_id) this.props.selectTag({ ...selectedSegment, segment: true });
    else if (is_identified) this.props.selectTag({ id: tag_id, is_identified });
  }

  getTagId(location) {
    const search = get(location, 'search', '');
    if (!search.includes('tag_id')) return 0;
    const tag_id = this.getNumberFromString(search);
    return tag_id;
  }

  getSegmentId(location) {
    const search = get(location, 'search', '');
    if (!search.includes('segment_id')) return 0;
    const segment_id = this.getNumberFromString(search);
    return segment_id;
  }

  getIsIdentifyStatus(location) {
    const search = get(location, 'search', '');
    if (!search.includes('is_identified')) return false;
    const is_identified = search.replace(/(.*)=/gm, '');
    return is_identified;
  }

  getNumberFromString(string) {
    const match = string.match(/\d+/);
    if (!match || !match[0]) return false;
    return parseInt(match, 10);
  }

  toggleSidebar() {
    const { openSidebar } = this.state;
    this.setState({ openSidebar: !openSidebar });
  }

  triggerLinkActions() {
    this.openDetailsUser();
  }

  openDetailsUser() {
    const { match, handleSelectUser } = this.props;
    const user_id = get(match, 'params.user_id');
    const view_name = get(match, 'params.view_name');
    handleSelectUser(user_id, view_name);
  }

  render() {
    const { openSidebar } = this.state;
    const {
      selectedTag,
      next,
      selectedUsers,
      handleClearUsersSelection,
      handleRemoveUsersTagsToggle,
      handleToggleUserDialog,
      handleSelectUser,
      handleSelectUsers,
      users,
      usersPending,
      usersSuccess,
      usersFailure,
    } = this.props;

    return (
      <Container>
        <Sidebar
          openSidebar={openSidebar}
        />

        <Main isOpen={openSidebar}>
          <Header>
            <Title
              toggleSidebar={this.toggleSidebar}
              openSidebar={openSidebar}
              selectedTag={selectedTag}
            />

            <Filters
              handleToggleUserDialog={handleToggleUserDialog}
              handleClearUsersSelection={handleClearUsersSelection}
              handleRemoveUsersTagsToggle={handleRemoveUsersTagsToggle}
            />
          </Header>

          <UsersTable
            users={users}
            next={next}
            updateUsersData={this.props.updateUsersData}
            selectedUsers={selectedUsers}
            usersPending={usersPending}
            usersSuccess={usersSuccess}
            usersFailure={usersFailure}
            handleSelectUser={handleSelectUser}
            handleSelectUsers={handleSelectUsers}
          />

          <Details />

          <AddTag />

          <RemoveUsersTags />
        </Main>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  tags: selectTags(state),
  next: getUsersNext(state),
  selectedTag: selectSelectedTag(state),
  tagSuccess: getTagsSuccess(state),
  selectedUsers: getSelectedUsers(state),
  users: getUsers(state),
  usersPending: getUsersPending(state),
  usersSuccess: getUsersSuccess(state),
  usersFailure: getUsersFailure(state),
  segments: selectSegments(state),
  segmentsStatus: getSegmentsStatus(state),
});

const mapDispatchToProps = dispatch => {
  return {
    fetchUsersData: ({ tag_id, segment_id, is_identified } = {}) => dispatch(fetchUsers({ tag_id, segment_id, is_identified })),
    handleSelectUser: (user_id, eventName) => dispatch(selectUser(user_id, eventName)),
    handleClearUsersSelection: (user_id, eventName) => dispatch(clearUsersSelection(user_id, eventName)),
    handleSelectUsers: user => dispatch(selectUsers(user)),
    handleToggleUserDialog: () => dispatch(toggleUserDialog()),
    handleRemoveUsersTagsToggle: () => dispatch(removeUsersTagsToggle()),
    fetchTagsData: () => dispatch(fetchTags()),
    selectTag: tag => dispatch(selectTag(tag)),
    updateUsersData: (users, next) => dispatch(updateUsersData({ users, next })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Users.jsx